import type { Ref } from 'vue'
import type { User } from '~/composables/charon'

export function useMe(): Ref<Readonly<User | null>> {
  const { data } = useAuth()
  return useState('user-me', () => data.value?.user ?? null)
}
